import { render, staticRenderFns } from "./comment-thread.vue?vue&type=template&id=128f51af&"
import script from "./comment-thread.vue?vue&type=script&lang=js&"
export * from "./comment-thread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports